import { useCallback, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { cx } from '@libs/classnames';
import { Form } from '@ui/components/Form';
import { ThemeButton } from '@ui/components/ThemeButton';

import { ClubIdInput, TitleInput } from '@features/club/ui/ClubFormInput';

import styles from './ClubCreateForm.module.css';

export type FormValues = {
  clubId: string;
  title: string;
};

export type Props = {
  className?: string;
  onCancel: () => void;
  onSubmit: (newClub: FormValues) => Promise<FormValues>;
};

export function ClubCreateForm({
  className,
  onCancel,
  onSubmit,
}: Props) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const clubForm = useForm<FormValues>({
    disabled: isSubmitting,
    defaultValues: {
      clubId: '',
      title: '',
    },
  });

  const handleSubmit = useCallback(async () => {
    setIsSubmitting(true);
    try {
      await onSubmit(clubForm.getValues());
    } finally {
      setIsSubmitting(false);
    }
  }, [onSubmit, clubForm]);

  return (
    <FormProvider {...clubForm}>
      <form onSubmit={handleSubmit}>
        <Form className={cx(className, styles.root)}>
          <TitleInput required />
          <ClubIdInput />

          <div className={styles.buttonBar}>
            <ThemeButton inverted onClick={onCancel}>
              Отмена
            </ThemeButton>
            <ThemeButton
              onClick={handleSubmit}
              disabled={!clubForm.formState.isValid || isSubmitting}
            >
              Сохранить
            </ThemeButton>
          </div>
        </Form>
      </form>
    </FormProvider>
  );
}
